module.exports = __webpack_public_path__ + "img/front.6e02c89b.png";